import { apiClient } from './api';

/**
 * Auth Service
 * Handles authentication and account-related API calls
 */
export const authService = {
  /**
   * Login with IronSource credentials
   * @param {string} email - IronSource account email
   * @param {string} secretKey - IronSource secret key
   * @param {string} refreshToken - IronSource refresh token (required)
   * @returns {Promise} Login response with token
   */
  login: async (email, secretKey, refreshToken) => {
    const response = await apiClient.post('/auth/login', {
      email,
      secret_key: secretKey,
      refresh_token: refreshToken,
    });

    // Store token in localStorage
    if (response.data?.token) {
      localStorage.setItem('auth_token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('account', JSON.stringify(response.data.account));
    }

    return response;
  },

  /**
   * Logout
   * @returns {Promise} Logout response
   */
  logout: async () => {
    try {
      await apiClient.post('/auth/logout');
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      // Clear local storage regardless of API response
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      localStorage.removeItem('account');
    }
  },

  /**
   * Check if user is authenticated
   * @returns {boolean}
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('auth_token');
  },

  /**
   * Get current user
   * @returns {Object|null}
   */
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  /**
   * Get current account
   * @returns {Object|null}
   */
  getCurrentAccount: () => {
    const accountStr = localStorage.getItem('account');
    return accountStr ? JSON.parse(accountStr) : null;
  },

  /**
   * Get user accounts
   * @returns {Promise} Accounts list
   */
  getAccounts: () => {
    return apiClient.get('/auth/accounts');
  },
};
